// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"465":"c4b83d53","500":"07f317cf","942":"ffaed82e"}[chunkId] + ".css";
};